/**
 * Coupon picked from the coupon ticket ("Use now"): carried to the cart through product pages.
 * The cart reads ?coupon= first, then this; it is cleared once read.
 */
export const PENDING_COUPON_KEY = 'yeap.pendingCoupon';

export const setPendingCoupon = (code) => {
    try {
        if (code) sessionStorage.setItem(PENDING_COUPON_KEY, String(code));
    } catch (e) { /* storage blocked */ }
};

/** "/cdn/plans" + code → "/cdn/plans?coupon=CODE" (keeps an existing query). */
export const withCoupon = (path, code) => (code ? `${path}${path.includes('?') ? '&' : '?'}coupon=${encodeURIComponent(code)}` : path);
